import { Ng2StateDeclaration } from '@uirouter/angular';

export const accountState: Ng2StateDeclaration = {
  name: 'app.account',
  abstract: true,
};
